export default __webpack_public_path__ + "static/media/bootstrap.c64ac3ea.svg";